<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="confirm-modal-container"
    title="確認"
  >
    <template v-slot:body="{ cancel, ok }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <v-container>
          <div class="modal-body msg-pre-line">
            {{ message }}<br />
            一度ポリシーに適用したアドレスオブジェクトを変更/削除する場合は再度ポリシーの設定が必要になります。<br />
            詳細は下記Webマニュアルをご確認ください。<br />
            <a
              href="https://wvs2document.com/type4-extra-site-ref/"
              target="_blank"
              >エクストラサイト設定参照(Type4) (変更/削除)</a
            >
          </div>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="ok" variant="flat" color="primary">はい</v-btn>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Type4ExtraSiteConfirmModal",
  props: {
    message: {
      type: String as PropType<string>,
      required: true,
    },
  },
});
</script>
